import * as React from 'react';
import { DamVideo, DamVideoProps } from '@/components/features/cms/blocks/DamVideo/DamVideo';
import { SegmentationContext } from '@/contexts/SegmentationContext';
import { useGetTranslations } from '@/generated/translations';

export const DamVideoWithOverrides: React.FC<DamVideoProps> = (props) => {
	const { segmentationId } = React.useContext(SegmentationContext);
	const { data: translations } = useGetTranslations(segmentationId);
	return <DamVideo {...props} unsupportedVideoMessage={translations?.data.shared.unsupportedVideo} />;
};
